import styled from "styled-components";

export const ContentWrapperWithPadding = styled.div`
  white-space: pre-wrap;
  padding: 30px;
`;
